<template>
    <v-container>
        <v-layout row class="my-2" id="orderFilterButton">
            <v-flex xs12>
                <h2 class="hidden-sm-and-down">{{txc.title}}</h2>
            </v-flex>
            <v-flex xs12 class="new-button">
                <button small flat outline class="secondary-hit right" v-on:click="exportToCSV(orders)">
                    <span class="icon icon-export"></span>
                    {{sharedStrings.generic.export_csv}}
                </button>
            </v-flex>
        </v-layout>
        <div id="orderHistoryPage">
            <v-layout wrap align-center id="orderHeader">
                <v-flex xs6 md4 flex>
                    <div style="margin-right:10px;">
                        <div class="field-label">{{txc.date_range}}</div>
                        <v-select
                            v-model="dateFilter"
                            :items="dateFilters"
                            item-text="text"
                            item-value="value"
                            return-object
                            @change="checkFilters"
                        />
                    </div>
                </v-flex>
                <v-flex xs6 md4 flex>
                    <div style="margin-left:10px;">
                        <div class="field-label">{{txc.order_status}}</div>
                        <v-select
                            v-model="statusFilter"
                            :items="statusFilters"
                            item-text="text"
                            item-value="value"
                            return-object
                            @change="runFilters"
                        />
                    </div>
                </v-flex>
            </v-layout>
            <div v-if="filteredOrders.length > 0">
                <paginate name="orders" :list="filteredOrders" :per="50" />
                <v-card
                    flat
                    v-for="order in paginated('orders')"
                    :key="order.OrderNumber"
                    class="mb-2 mt-2 orderItems"
                >
                    <v-card-text>
                        <v-layout align-space-around justify-space-around row fill-height>
                            <v-flex xs6 fill-height>
                                <div class="orderInfo">
                                    <div class="orderNumber">
                                        <strong>
                                            <span>{{txc.order_number}}:</span>
                                            {{order.OrderNumber}}
                                        </strong>
                                    </div>
                                    <div class="orderDate">
                                        <span>{{txc.date}}:</span>
                                        {{formatDateString(order.OrderDate)}}
                                    </div>
                                    <div class="orderTotal">
                                        <span>{{txc.total}}:</span>
                                        <span v-if="marketLoggedIn == 'JP'">
                                            {{currency}}{{order.Amount}}
                                        </span>
                                        <span v-else>
                                            {{currency}}{{order.Amount.toFixed(2)}}
                                        </span>
                                    </div>
                                    <div class="orderPSV">
                                        <span>{{txc.psv}}:</span>
                                        {{order.PSV}}
                                    </div>
                                    <div class="orderStatus">
                                        <span>{{txc.order_status}}:</span>
                                        <span class="text-uppercase">{{statusTranslate(order.Status)}}</span>
                                    </div>
                                    <div v-if="order.Tracking !=null">
                                        <v-layout>
                                            <v-flex class="trackingBlock">{{txc.tracking_number}}:</v-flex>
                                            <v-flex>
                                                <span v-for="(item, index) in order.Tracking" :key="index">
                                                    <a
                                                        @click="showTracking(item.TrackURL)"
                                                        v-if="!marketConfig.trackingLinkUnavailable.includes(item.Carrier)"
                                                    >{{item.TrackNumber}}</a>
                                                    <span v-else>{{item.TrackNumber}}</span>
                                                    <br />
                                                </span>
                                            </v-flex>
                                        </v-layout>
                                    </div>
                                </div>
                            </v-flex>
                            <v-flex xs6>
                                <div class="detailSection text-right">
                                    <div class="viewDetails">
                                        <a @click="showDetails(order.OrderNumber)">{{txc.view_details}}</a>
                                    </div>
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
                <div class="page-links" v-if="filteredOrders.length > 24">
                    <paginate-links
                        for="orders"
                        :show-step-links="true"
                        :limit="5"
                        :hide-single-page="true"
                        :click="onLangsPageChange()"
                    />
                </div>
            </div>
            <loader v-show="processing" />
            <div v-if="noOrders">
                <v-card flat class="mb-2 mt-2">
                    <v-card-text>{{txc.no_orders_found}}</v-card-text>
                </v-card>
            </div>
            <div id="distributorDisclaimer" class="distributorsOnly" v-if="isDistributor">
                <p v-html="txc.v_and_g_desc"></p>
            </div>
        </div>
    </v-container>
</template>

<script>
import { ProfileService } from '@nuskin/ns-account'
import * as ruleset from '../repositories/globalRules.js'
import { CurrencyService } from '@nuskin/ns-shop'
import Loader from '../components/Loader'

import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import profileUtils from '../repositories/profileUtils'
import genhelpmethods from '../helpers/genhelpmethods'
import orderHistoryHelper from '../helpers/components/orderhistory'

export default {
    name: 'OrderHistory',
    components: {
        Loader
    },
    data() {
        return {
            filteredOrders: [],
            orders: [],
            paginate: ['orders'],
            status: '',
            ruleSet: ruleset,
            noOrders: false,
            dateFilter: {},
            statusFilter: {},
            filterDialog: false,
            processing: false,
            loadedAllOrders: false,
            trackingLinkUnavailable: ''
        }
    },
    computed: {
        ...mapGetters({
            fullScreenModals: 'mobileView',
            txc: 'translationsOrderHistory',
            sharedStrings: 'sharedStrings',
            marketLoggedIn: 'marketLoggedIn',
            account: 'account',
            isDistributor: 'isDistributor',
            marketConfig: 'marketConfig'
        }),
        dateFilters() {
            return [
                { text: this.txc.one_month, value: '1' },
                { text: this.txc.three_months, value: '3' },
                { text: this.txc.six_months, value: '6' },
                { text: this.txc.twelve_months, value: '12' }
            ]
        },
        statusFilters() {
            return [
                { text: this.txc.all, value: '' },
                {
                    text: this.txc.backorder,
                    value: 'BACKORDER'
                },
                {
                    text: this.txc.cancelled,
                    value: 'CANCELLED'
                },
                { text: this.txc.complete, value: 'COMPLETE' },
                { text: this.txc.declined, value: 'DECLINED' },
                {
                    text: this.txc.incomplete,
                    value: 'INCOMPLETE'
                },
                {
                    text: this.txc.partial_return,
                    value: 'PARTIAL_RETURN'
                },
                {
                    text: this.txc.payment_pending,
                    value: 'PAYMENT_PENDING'
                },
                { text: this.txc.pending, value: 'PENDING' },
                {
                    text: this.txc.pending_return,
                    value: 'PENDING_RETURN'
                },
                {
                    text: this.txc.processing,
                    value: 'PROCESSING'
                },
                { text: this.txc.returned, value: 'RETURNED' }
            ]
        },
        currency() {
            return CurrencyService.getCurrency(this.marketLoggedIn).symbol
        }
    },
    methods: {
        ...mapActions(['addTrackingInfo']),
        showDetails(orderNumber) {
            orderHistoryHelper.showDetails(this, orderNumber, profileUtils)
        },
        showTracking(trackURL) {
            genhelpmethods.showTracking(trackURL)
        },
        formatDateString(stringDate) {
            return genhelpmethods.formatDateString(stringDate)
        },
        removeFilter(item) {
            orderHistoryHelper.removeFilter(this, item)
        },
        checkFilters() {
            orderHistoryHelper.checkFilters(this)
        },

        runFilters() {
            orderHistoryHelper.runFilters(this)
        },
        filterStatus(selected) {
            orderHistoryHelper.filterStatus(this, selected)
        },
        filterDate(selected) {
            orderHistoryHelper.filterDate(this, selected, moment)
        },
        clearFilters() {
            orderHistoryHelper.clearFilters(this)
        },
        parseDate(dateToParse) {
            return genhelpmethods.parseDate(dateToParse)
        },
        sortJSON(data, key, way) {
            return genhelpmethods.sortJSON(data, key, way)
        },
        exportToCSV(arr) {
            orderHistoryHelper.exportToCSV(this, arr, profileUtils)
        },
        onLangsPageChange() {
            return genhelpmethods.onLangsPageChange();
        },
        loadOrders(months, updateFilter) {
            orderHistoryHelper.loadOrders(
                this,
                ProfileService,
                months,
                updateFilter
            )
        },
        statusTranslate(status) {
            return orderHistoryHelper.statusTranslate(this, status)
        }
    },
    mounted() {
        orderHistoryHelper.mounted(this)
    }
}
</script>

<style lang="scss">
.page-links {
    ul {
        margin-top: 20px;
        text-align: center;

        li {
            display: inline;
            padding: 10px;
        }
    }
}

#distributorDisclaimer {
    margin-top: 10px;
}

.orderInfo {
    line-height: 1.5em;
}

.detailSection {
    text-transform: uppercase;
    color: #440099;

    .viewDetails {
        font-size: 13px;

        a {
            text-transform: uppercase;
            text-decoration: none;
            color: #7123d9;

            &.left-20 {
                margin-left: 20px;
            }
        }
    }
}

.v-input__slot {
    background-color: #fff;
}

#orderFooter {
    margin-top: 10px;
}

.trackingBlock {
    flex-basis: 5%;
    white-space: nowrap;
    padding-right: 5px;
}

@media screen and (max-width: 767px) {
    #orderHeader {
        padding: 10px 20px 10px 10px;
    }
    #clearFilter {
        text-align: center;
        width: 175px;
    }

    #clearFilter label {
        display: none;
    }
}

@media screen and (max-width: 374px) {
    body {
        background: #f6f7f7;
        font-size: 14px;
    }
}
</style>
